import { inject, Injectable } from '@angular/core';
import { Patient } from '@pixacare/domain';
import { SadmClient } from '@pixacare/dtos';
import { DialogService } from '@services/dialog.service';
import { Observable } from 'rxjs';
import { SadmGridComponent } from '../components/sadm-grid/sadm-grid.component';

@Injectable({
  providedIn: 'root',
})
export class SadmGridService {
  private readonly dialogService = inject(DialogService);

  openGrid(sadmClient: SadmClient, patient: Patient): Observable<void> {
    return this.dialogService.openComponent<SadmGridComponent, void>(SadmGridComponent, {
      data: { sadmClient, patient },
      appearance: 'page',
      closable: false,
      dismissible: false,
    });
  }
}
